export const getSearchDebounce = async (event: Event, callback: (target: HTMLInputElement) => void) => {
    
    const target = event?.target as HTMLInputElement
    
    // if(target?.value.length <= 0) return

    callback(target)

    return target
}